// extracted by mini-css-extract-plugin
module.exports = {"login":"e27f3eaa","smallCode":"_3a269a9a"};